/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfigCcex = {
    auth: {
        clientId: `${process.env.REACT_APP_CLIENT_ID_CCEX}`,
        authority: `${process.env.REACT_APP_AUTHORITY_CCEX}`,
        redirectUri: `${process.env.REACT_APP_FRONT}`
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }	
                // console.log(`${process.env.REACT_APP_FRONT}`)	
                switch (level) {
                    case LogLevel.Error:
                       // console.error(message);
                        break;
                    case LogLevel.Info:
                        //console.info(message);
                        break;
                    case LogLevel.Verbose:
                        //console.debug(message);
                        break;
                    case LogLevel.Warning:
                        //console.warn(message);
                        break;
                    default:
                        break;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequestCcex = {
    scopes: ["User.Read"],
    prompt: "select_account"
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfigCcex = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me" //e.g. https://graph.microsoft.com/v1.0/me
};
